const Activity = {
  path: '/audit',
  name: 'audit',
  component: () => import('@/views/audit/index.vue'),
  children: [
    {
      path: 'supervisopn-reporting',
      name: 'audit-supervisopn-reporting',
      component: () =>
        import(
          /* webpackChunkName: "p150-paddle-gifts" */ '@/views/audit/supervisopn-reporting.vue'
        ),
    },
  ],
}
export default Activity
